import React, {useEffect, useState, useRef } from "react";
import { Modal, Slide, ClickAwayListener, Fade, Alert } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useSelector, useDispatch } from "react-redux";
import { baseUrlDev } from "../../../Helpers/baseUrl";
import { fetchNewLocations, clearNewLocations, fetchUserInfo, fetchCompetitors, clearCompetitors } from "../../../../redux/actions/admin-index";
import { IoLocationOutline }  from "react-icons/io5";
import { getLocalUser } from "../../../TokenControl/parts/useLocalUser";
import axios from "axios";
import { showAlert } from "../../../../redux/actions";
import AlertComponent from "../../../Helpers/Alert";

const AddLocation = ({open, setOpen, title, callback}) => {
    const dispatch = useDispatch()
    const [value, setValue] = useState('')
    const [searching, setSearching] = useState(false)
    const [selected, setSelected] = useState('')
    const [loading, setLoading] = useState(false)
    const [errors, setErrors] = useState([])
    const timeoutRef = useRef(null);


    const handleClose = () => {
        setOpen(false)
        setValue('')
        setSelected('')
        setSearching(false)
        setLoading(false)
        dispatch(clearNewLocations())
    }

    const locations = useSelector(state => state.newLocations.locations)
    const location = useSelector(state => state.locationSelected.location)
    const selectedLoc = useSelector(state => state.groupLocationSelected.group_location)


    useEffect(() => {
        if(locations){
            setSearching(false)
        }
    }, [locations])

    const getLocations = (val) => {
        setValue(val);
      
        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
        }
        timeoutRef.current = setTimeout(() => {
          if (val.length > 2) {
            dispatch(fetchNewLocations(val));
            setSearching(true);
          } else {
            setSearching(false);
            dispatch(clearNewLocations());
          }
        }, 300);
      };

    const chooseLocation = (name, id) => {
        setValue(name)
        setSelected(id)
        dispatch(clearNewLocations())
    }
    const submitLocation = () => {
        setLoading(true)
        axios.post(`${baseUrlDev}locations/create`, {place_id: selected}, {headers:{'Authorization': `Bearer ${getLocalUser().token}`, 'APP-VERSION': 'react' }})
        .then((res) => {
            setLoading(false)
            if(res?.data?.data?.location){
                if(typeof callback === "function"){
                    callback(res?.data?.data?.location)
                } else {
                    dispatch(fetchUserInfo())
                }
            }
            handleClose()
            dispatch(showAlert(true, "New Location Added Successsfully!"))
            setTimeout(() => {
                dispatch(showAlert(false, ""))
            }, 5000)
        }).catch((err) => {
           let all_errors = err?.response?.data?.errors  
           let message = err?.response?.data?.message
           if(all_errors && Object.values(all_errors).length > 0){
                Object.keys(all_errors).map(key => {
                    setErrors(errors => [...errors, all_errors[key][0]])
                })
           } else {
                setErrors(errors => [...errors, message ? message : "Something went Wrong!"])
           }
           setTimeout(() => {
               setErrors([])
            }, 5000)
            setLoading(false)
        })

    }

    const submitCompetitorFunc = (id) => {
        setLoading(true)
        axios.post(`${baseUrlDev}locations/competitors/${id}`, {place_id: selected}, {headers:{'Authorization': `Bearer ${getLocalUser().token}`, 'APP-VERSION': 'react' }}).then(() => {
            setLoading(false)
            dispatch(clearCompetitors())
            dispatch(fetchCompetitors(id))
            handleClose()
            dispatch(showAlert(true, "New Competitor Added Successsfully!"))
            setTimeout(() => {
                dispatch(showAlert(false, ""))
            }, 5000)
        }).catch((err) => {
            let all_errors = err?.response?.data?.errors  
            if(all_errors && Object.values(all_errors).length > 0){
                 Object.keys(all_errors).map(key => {
                     setErrors(errors => [...errors, all_errors[key][0]])
                 })
            }
            setTimeout(() => {
                setErrors([])
             }, 5000)
             setLoading(false)
        })
    }
    const submitCompetitor = () => {
        if(selectedLoc && (!location || location == "all")){
            submitCompetitorFunc(selectedLoc)
        }
        if (location && location !== "all") {
            submitCompetitorFunc(location)
        }
    }

    return(
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-location-title"
            aria-describedby="modal-location-description"
        >
            <Slide direction="left" in={open} {...({ timeout: 500 })}>
                <div className={`custom-modal-dialog`}>
                    {errors && errors.map(err => {
                        return (
                            <div className="alert-inside-modal" key={err}>
                                <Alert severity="error" className="custom-error-alert">{err}</Alert>
                            </div>
                        )
                    })}
                    <AlertComponent/>
                    <div className="notification-modal-body">
                        <div className="custom-modal-header">
                            <h5>Add New {title}</h5>
                        </div>
                    </div>
                    <div className="custom-modal-content">
                        <div className="scrollable-loc-container custom-scrollbar-vertical">
                            <div className="field-container">
                                <label>Add New {title}</label>
                                <input type="search" value={value}
                                    placeholder={`Search for ${title}`} 
                                    onChange={(e) => getLocations(e.target.value)}
                                />
                            </div>
                            {searching && <div className="field-container location-item">Searching...</div>}
                            <Fade in={locations && locations.length > 0}>
                                <div className="field-container">
                                    <div className="location-res-container custom-scrollbar-vertical">
                                        {locations && locations.length > 0 ? locations.map(loc => {
                                            return(
                                                <div key={loc.place_id} className="location-item location-item-hover" onClick={() => chooseLocation(loc.description, loc.place_id)}><IoLocationOutline/> {loc.description}</div>
                                            )
                                        })
                                        :<div className="field-container location-item location-item">No result found</div>
                                     }
                                    </div>
                                </div>
                            </Fade>
                        </div>
                    </div>
                    <div className="custom-modal-footer">
                        <LoadingButton
                            style={{paddingLeft: loading && "30px"}}
                            className="save-btn"
                            onClick={() => title === "Location" ? submitLocation() : submitCompetitor()}
                            loading={loading}
                        >
                            Save
                        </LoadingButton>
                        <button className="close-btn" onClick={() => handleClose()}>Close</button>
                    </div>
                </div>
            </Slide>
        </Modal>
    )
}
export default AddLocation